<template>
  <div class="container">
    <div class="title">
      <div>{{ title }}</div>
      <div class="back" @click="back">
        <img src="@/assets/img/back.png" alt="" />
        返回列表
      </div>
    </div>

    <div class="content">
      <div class="content-title">
        {{ articleInfo.masTitle }}
      </div>
      <div class="content-time">
        <div style="margin-right: 32px">
          发布时间：{{ articleInfo.dpubDate }}
        </div>
        <div>发布单位：{{ articleInfo.source }}</div>
      </div>

      <div class="driver"></div>

      <!-- <div class="content-article" v-html="articleInfo.content"></div> -->
      <div class="editor-html content-article" v-html="articleInfo.content"></div>
      <div class="file-con" v-if="fileList && fileList.length">
        <div class="file-label">附件：</div>
        <div class="file-list" v-for="(item,index) in fileList" :key="item.id">
          <div class="file-item-name" @click="checkFile(item)" title="点击下载">{{index + 1 }}. {{ item.title }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from "@/utils/api.js";
import { downloadFile } from "@/utils/document.js";
export default {
  name: "newDetail",
  props: {
    title: {
      type: String,
      default: "",
    },
    id: {
      type: [String, Number],
      required: true,
    },
  },

  watch: {
    // 监听 props id 的变化
    id: {
      handler(newId) {
        if (newId) {
          this.init(newId);
        } else {
          this.init(this.$route.query.detailId);
        }
      },
      immediate: true, // 组件初始化时也会立即调用
    },
  },
  data() {
    return {
      articleInfo: {},
      fileList: [],
    };
  },

  methods: {
    async init(id) {
      const res = await api.getInfoDetail(id);
      console.log(res);
      this.articleInfo = res.data;
      this.getFlieList();
    },
    back() {
      this.$emit("back");
    },
    async getFlieList() {
      const {code, data} = await api.getFlieList({
        affairId: this.articleInfo.affairId || '1761635905540101443',
        type: '',
        classified: ''
      });
      if(code == '00000') {
        this.fileList = data;
      }
    },
    // 
    async checkFile(item) {
      // window.open(url);
      const res = await api.checkFile(item.path+item.fileName);
      if(res.code == '00000') {
        downloadFile('downloadFile', {
          fileName: item.title,
          filePath: item.path+item.fileName,
        }, item.title);
      }
    },
  },
};
</script>

<style lang="less" scoped>
.container {
  padding: 32px;
}
.title {
  margin-bottom: 12px;
  font-size: 20px;
  font-weight: bold;
  color: #01206c;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.back {
  font-size: 16px;
  color: #696e74;
  cursor: pointer;
}
.content {
  margin-top: 40px;
}
.content-title {
  font-size: 36px;
  font-weight: bold;
  line-height: normal;
  text-align: center;
  color: #1f2d3d;
  padding: 0 100px;
}
.content-time {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 16px;
  line-height: 16px;
  margin-top: 16px;
  color: #696e74;
}
.content-article {
  font-size: 18px;
  font-weight: normal;
  line-height: 32px;
  color: #333333;
  text-indent: 2em;
}
.driver {
  width: 100%;
  height: 1px;
  background-color: #e2e8f0;
  margin: 40px 0;
}
.file-con {
  margin-top: 16px;
  font-size: 18px;
  .file-label {
    color: #116DC0;
  }
  .file-list {
    padding-left: 20px;
    margin-top: 16px;
    cursor: pointer;
    &:hover {
      color: #116DC0;
    }
  }
}
</style>
